import React, { useEffect } from 'react';
import { createAppContext } from 'mini-app-context';
import { MountProps, MountPropsProvider } from 'mini-people-card-mount-props-provider';
import { PeopleCardModule } from 'mini-people-card-module';
import { registerWorkflowsForPeopleCard } from '../utils/registerWorkflowsForPeopleCard';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import {
    PEOPLE_CARD_WARM_LAUNCH_BEGIN,
    PEOPLE_CARD_COLD_LAUNCH_BEGIN,
} from 'mini-people-common/lib/utils/eventSignalConstants';

const PeopleCardModuleWrapper = React.memo((props: MountProps) => {
    const loggingContext = createAppContext();

    useEffect(() => {
        // Register all workflows initiated from People Card
        registerWorkflowsForPeopleCard();
    }, []);

    signalWorkflowEvent(
        PEOPLE_CARD_WARM_LAUNCH_BEGIN,
        {
            sourceMailboxType: props?.emailAddress?.MailboxType,
        },
        {
            isCore: true,
        }
    );
    signalWorkflowEvent(
        PEOPLE_CARD_COLD_LAUNCH_BEGIN,
        {
            sourceMailboxType: props?.emailAddress?.MailboxType,
        },
        {
            isCore: true,
        }
    );

    return (
        <MountPropsProvider mountProps={{ ...props, loggingContext }}>
            <PeopleCardModule />
        </MountPropsProvider>
    );
});

export default PeopleCardModuleWrapper;
